import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services';
import { filter, firstValueFrom, timeout } from 'rxjs';

export const isEmailVerified: CanActivateFn = async (): Promise<boolean> => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const userAuth = await firstValueFrom(
    authService.userAuth$.pipe(
      filter((ua) => ua.user !== undefined),
      timeout(10_000),
    ),
  ).catch(() => null);

  if (!userAuth || userAuth.user?.email_verified !== true) {
    await router.navigate(['/auth/verification']);
    return false;
  }

  return true;
};
